<template>
<v-layout row justify-center class="billingModule">
  <v-flex md3 class="sidebar">
    <aside>
      <ul>
        <li>
          <router-link to="/forms/employee-registration">Employee Register</router-link>
        </li>
        <li>
          <router-link to="/forms/visit-register" >Visit Register</router-link>
        </li>
        <li >
          <router-link to="/forms/monthly-report" >Monthly Report</router-link>
        </li>
        <li class="active" >
          <router-link to="/forms/patient-list" >Patient List</router-link>
        </li>
        <li >
          <router-link to="/forms/brand-list" >Brand List</router-link>
        </li>

        <li >
          <router-link to="/forms/pharma-company-list" >Pharma Company List</router-link>
        </li>

        <!-- <li>
          <router-link to="/forms/periodic-brand-count" >Periodic Brand Count</router-link>
        </li> -->
      </ul>
    </aside>
  </v-flex md3>
  <v-flex md9 pl-3 pr-3>
  <v-container>
    <v-layout row wrap>
      <v-flex xs9>
      <h1 class="title">Patient List</h1>
      </v-flex>

           <v-flex xs3>
      <!-- <el-date-picker
      v-model="dateRange"
      type="daterange"
      :picker-options="datePickerOptions"
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      align="right"
      format="dd-MM-yyyy"
      @change="getVisitRegistry"
      >
    </el-date-picker> -->
<el-dropdown   @command="sendAsEmail">
  <span class="el-dropdown-link" style="margin-left:5px">
    Share <i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item  command="pdf">PDF via Email</el-dropdown-item>
    <el-dropdown-item command="excel" divided>Excel via Email</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>

      </v-flex>

    </v-layout>
  </v-container>


    <v-layout row wrap>
<el-table
      v-loading="isLoading"
      :data="responseData"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        width="180">
      </el-table-column>
      <el-table-column
        prop="number"
        label="Mobile"
        >
      </el-table-column>

    <el-table-column
        prop="age"
        label="Age"
        >
      </el-table-column>


    <el-table-column
        prop="gender"
        label="Gender"
    >

    </el-table-column>

    <el-table-column
        prop="first_visit_date"
        label="First Visit"
    >

    </el-table-column>


    <el-table-column
        prop="last_visit_date"
        label="Last Visit"
    >
    </el-table-column>

      <el-table-column
        prop="last_diagnosis"
        label="Last Diagnosis">
      </el-table-column>

            <el-table-column
        prop="known_diagnosis"
        label="Known Diagnosis">
      </el-table-column>
    </el-table>
  </v-layout>
      <v-container>
    <v-layout row wrap>
      <v-flex xs9>
        <!-- TODO: Total from API? -->
          <el-pagination
        layout="prev, pager, next"
        :total="100"
        style="text-align:center"
        @current-change="changePage"
        >
      </el-pagination>
      </v-flex>
    </v-layout>
</v-container>
  </v-flex>

</v-layout>

</template>
<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { api, REPORTS_API_ROOT } from '../api.js';
import {formatDate} from '../util.js'
import {get, post} from 'axios';
const queryString = require('query-string');
import { Notification } from 'element-ui';

export default {
  userName: '',
  components: {
    // NOTE: don't forget to add components here after import
    // sample in next line
    // VueGoogleAutocomplete
  },
  beforeRouteLeave: (to,from,next)=>{
    // NOTE: add any action to be performed before leaving the route here
    // the next() is important
    // so add everything before next()
    // sample in next line
    // console.log("Loggin before leaving route");
    next()
  },
  data() {
    return {
      isLoading:false,
      snackbar: false,
      snackbarColor: '',
      mode: '',
      timeout: 6000,
      snackbarText: 'Hello, I\'m a snackbar',
      dateRange:{},
      currentPage:1,
      responseData:[],
        datePickerOptions: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    } // return statement end
    }, // data() end
  mounted() {
    // NOTE: add actions to be performed on-mount
this.getVisitRegistry();
this.$on('pick', function (msg) {
  console.log(msg)
})
},
methods: {    sendAsEmail(type='pdf'){
      const requestQueryString = {
        clinic_id:localStorage.clinic_id,
        mail:true
      }

      if(this.dateRange && this.dateRange.length <= 2){
        requestQueryString.from_date = formatDate(this.dateRange[0])
        requestQueryString.to_date = formatDate(this.dateRange[1])
      }

      if(type==='pdf'){
        requestQueryString.sending_format = 'pdf'
      }

      if(type==='excel'){
        requestQueryString.sending_format = 'excel'
      }
      const loading = this.$loading({
          lock: true,
          text: `${type} report is being processed`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

      get(REPORTS_API_ROOT + `/patient_list?${queryString.stringify(requestQueryString)}`)
        .then(res => {
          if(res.data.status){

          Notification({
            title: 'Email Report',
            message: `${type} report is being send to your email addresss`,
            type: 'success'
          });

        // window.alert(`${type} Report is being send to your email addresss`);
                      loading.close();
          }
        }).catch(err => {
                    console.log(err)
                    loading.close();

        })
    },
    changePage(pageNo){
      this.currentPage = pageNo;
      this.getVisitRegistry()
    },
    getVisitRegistry(dateRange=null){
      this.isLoading = true;
      // /employee_register?clinic_id=1&from_date=2018-08-01&to_date=2018-08-10'
      const requestQueryString = {
        clinic_id:localStorage.clinic_id,
        page_no:this.currentPage
      }

      if(dateRange && dateRange.length <= 2){
        requestQueryString.from_date = formatDate(dateRange[0])
        requestQueryString.to_date = formatDate(dateRange[1])
      }

      get(api + `/patient_list?${queryString.stringify(requestQueryString)}`)
        .then(res => {
          console.log(res);
          this.responseData = res.data.patients
        })
      this.isLoading = false;
    },
  }
}
</script>

<style lang="css" scoped>

.title{
  margin-top: 10px;
}
.el-input {
  width: 10px;
  margin: auto;
}
.addWrapper {
  text-align: center;
    display: flex;
    justify-content: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    align-items: center;
}
.add {
  /* padding: 3rem 0; */
}
.billingModule {
  min-height: 99vh;
}

#example-1 {
  font-size: 20px;
  padding: 20px;
  margin-left: 1.5rem;
}

#example-2 {
  /*padding: 20px;*/
}

#detail {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 30%; */
  margin-left: 2rem;
}

#charge {
  border: 1px solid #d8d8d8;
  /* border-radius: 4px; */
  padding: 8px;
  /* width: 15%; */
  /* margin: 10px; */
}

#qty {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 10%; */
}

.listOfCharges {
  display: flex;
}

#partiallyPaid {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 8px;
  width: 15%;
}

/* .card__title {
  background-color: #018FFF;
  color: white;
  font-size: 80px;
} */

ul {
  list-style: none;
}

.fa-times-circle-o {
  color: #8080808a;
}

.invoiceTotals {
  padding: 20px;
  margin-left: 1.5rem;
  text-align: right;
  padding-right: 5rem;
}

.invoiceTotals>h3 {
  margin: 10px 0px;
}

.sidebar {
  background-color: #383B3F;
  color: #fff;
}

.sidebar ul li {
  padding: 1rem;
}

.sidebar ul li a {
  color: white;
  text-decoration: none;
}

.sidebar .active {
  background-color: #F2994A;
}

.patient_profile>h4 {
  padding: 10px 10px 2px 10px;
}

.patient_profile>h5 {
  padding: 0 10px 10px;
}

.fa-inr {
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.card__actions {
  justify-content: flex-start;
  padding: 16px;
}

.autocompleteSelect {
  width: 65%;
}
</style>



// WEBPACK FOOTER //
// src/components/FormPatientList.vue